export default async function fetch(url: string, options?: RequestInit) {
  const response = await window.fetch(url, options);

  if (response.status !== 200) {
    let error: string;
    const plain = await response.text();

    try {
      error = JSON.parse(plain).message;
    } catch {
      error = plain;
    }

    throw new Error(error);
  }

  return response;
}
